import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

import { AdminPageHeader } from '@/features/admin/layout/admin-page-header'
import { useAdminOrganizationsForSelect } from '@/features/admin/organizations/hooks/use-admin-organizations'
import { UserForm } from '@/features/admin/users/components/user-form'
import { useCreateAdminUser } from '@/features/admin/users/hooks/use-create-admin-user'
import { router } from '@/router'

export const Route = createFileRoute('/admin/users/create')({
  component: AdminUserCreatePage,
})

function AdminUserCreatePage() {
  const { t } = useTranslation('admin')
  const { mutate, isPending } = useCreateAdminUser()
  const { data: organizations } = useAdminOrganizationsForSelect()

  return (
    <div className="space-y-4">
      <AdminPageHeader
        title={t('users.create.title')}
        subtitle={t('users.create.subtitle')}
      />
      <div className="mx-auto max-w-3xl">
        <UserForm
          organizations={organizations ?? []}
          isSubmitting={isPending}
          onSubmit={(data) => mutate(data)}
          onCancel={() => router.navigate({ to: '/admin/users' })}
          submitLabel={t('users.create.submit')}
        />
      </div>
    </div>
  )
}
